import { Contato } from "./contato";
import { Endereco } from "./endereco";

export class ComplementoEstudante {
    contato: Contato = new Contato();
    nacionalidade: string;
    naturalidade: string;
    endereco: Endereco = new Endereco();
}
